import {Entity} from '@s-ui/domain'

/**
 * @implements Entity
 * Motor Article (News)
 */
export default class ArticleEntity extends Entity {
  static FEATURED_ARTICLE_ID = 'publirreportaje'

  /**
   * @constructor
   * @param {Object} config
   * @param {Number} id
   * @param {Object} img
   * @param {Object} tag
   * @param {Number} numComments
   * @param {Boolean} commentsDisabled
   * @param {String} url
   * @param {String} title
   * @param {String} description
   * @param {Boolean} isVideo
   * @param {Boolean} shouldUseCommentsPage
   */
  constructor({
    articleId,
    config,
    id,
    img,
    tag,
    numComments,
    commentsDisabled,
    url,
    title,
    description,
    isVideo,
    shouldUseCommentsPage
  }) {
    super({
      articleId,
      config,
      id,
      img,
      tag,
      numComments,
      commentsDisabled,
      url,
      title,
      description,
      isVideo,
      shouldUseCommentsPage
    })

    this._articleId = articleId
    this._config = config
    this._id = id
    this._img = img
    this._tag = tag
    this._numComments = numComments
    this._commentsDisabled = commentsDisabled
    this._url = url
    this._title = title
    this._description = description
    this._isVideo = isVideo
    this._shouldUseCommentsPage = shouldUseCommentsPage
  }

  getCommentsUrl = () => {
    const {MIN_COMMENTS_TO_LINK_REVIEWS_PAGE} = this._config.get('COMMON')
    const {NEWS_COMMENTS_BASE_PATH} = this._config.get('page')

    const useCommentsPage = this._numComments >= MIN_COMMENTS_TO_LINK_REVIEWS_PAGE && this._shouldUseCommentsPage

    return useCommentsPage
      ? `${NEWS_COMMENTS_BASE_PATH}${this._url}`
      : `${this._url}${this._config.get('editorial').ARTICLE_COMMENTS_ANCHOR}`
  }

  isFeatured = () => this._tag && this._tag._id === ArticleEntity.FEATURED_ARTICLE_ID

  /**
   * @return {Object}
   */
  toJSON() {
    return {
      articleId: this._articleId,
      id: this._id,
      img: this._img.toJSON().url,
      tag: this._tag && this._tag.toJSON(),
      comments: this._commentsDisabled
        ? null
        : {
            count: this._numComments,
            url: this.getCommentsUrl()
          },
      url: this._url,
      title: this._title,
      description: this._description,
      featured: this.isFeatured(),
      video: this._isVideo
    }
  }
}
